__turbopack_context__.v({
  "column": "BlockNewsletter-module-scss-module__0WRQ9G__column",
  "columns": "BlockNewsletter-module-scss-module__0WRQ9G__columns",
  "copy": "BlockNewsletter-module-scss-module__0WRQ9G__copy",
  "error": "BlockNewsletter-module-scss-module__0WRQ9G__error",
  "flushBottom": "BlockNewsletter-module-scss-module__0WRQ9G__flushBottom",
  "flushTop": "BlockNewsletter-module-scss-module__0WRQ9G__flushTop",
  "form": "BlockNewsletter-module-scss-module__0WRQ9G__form",
  "headline": "BlockNewsletter-module-scss-module__0WRQ9G__headline",
  "image": "BlockNewsletter-module-scss-module__0WRQ9G__image",
  "imageOnLeft": "BlockNewsletter-module-scss-module__0WRQ9G__imageOnLeft",
  "imageWrap": "BlockNewsletter-module-scss-module__0WRQ9G__imageWrap",
  "input": "BlockNewsletter-module-scss-module__0WRQ9G__input",
  "inputLockup": "BlockNewsletter-module-scss-module__0WRQ9G__inputLockup",
  "inputLockupWrap": "BlockNewsletter-module-scss-module__0WRQ9G__inputLockupWrap",
  "inputSuccess": "BlockNewsletter-module-scss-module__0WRQ9G__inputSuccess",
  "inputWrap": "BlockNewsletter-module-scss-module__0WRQ9G__inputWrap",
  "joinError": "BlockNewsletter-module-scss-module__0WRQ9G__joinError",
  "joinErrorInner": "BlockNewsletter-module-scss-module__0WRQ9G__joinErrorInner",
  "legal": "BlockNewsletter-module-scss-module__0WRQ9G__legal",
  "lockup": "BlockNewsletter-module-scss-module__0WRQ9G__lockup",
  "newsLetterInner": "BlockNewsletter-module-scss-module__0WRQ9G__newsLetterInner",
  "root": "BlockNewsletter-module-scss-module__0WRQ9G__root",
  "submitButton": "BlockNewsletter-module-scss-module__0WRQ9G__submitButton",
});
